<template>
  <div class="dashboard-page-wrapper test-page">
    <div class="top-wrap">
      <div class="text-img">
        <h2> Sample Validation </h2>
        <div v-if="receivedData">
          <div v-if="pdfLoader === true" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_loader_image" alt="loader Image" />
            </div>
          </div>
          <div v-else-if="receivedData.testID !== ''" @click="goToPdf()" class="test-pdf-div">
            <div class="img-content">
              <img :src="pdf_icon" alt="pdf icon" />
            </div>
          </div>
        </div>
      </div>
      
      <!-- Black strip showing sampleType -->
      <div v-if="sampleData && sampleData.sampleType" class="sample-type-header">
        <h3>{{ sampleData.sampleType }}</h3>
      </div>

      <div class="top-content" v-if="receivedData && receivedData.headers && receivedData.headers.length > 0">
        <v-img src="../../../assets/Images/Assets/top image.png" alt="test image" width="49px" height="49px"></v-img>
        <div class="fields-info">
          <div class="fields-info-wrap" :style="{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '16px'
          }">
            <div
              v-for="(item, index) in receivedData.headers.filter(
                h => !(h.key && h.key.endsWith('_UOM'))
              )"
              :key="index"
              class="field-item"
            >
              <p style="margin: 0; font-weight: 500;">{{ item.displayName }}</p>
              <p class="test-top-values" style="margin: 0;">
                <v-tooltip location="top">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" v-if="typeof item.value === 'number'" class="value-text">
                      {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                    </span>
                    <span v-bind="props" v-else class="value-text">
                      {{ item.value }}
                    </span>
                  </template>
                  <span>{{ item.value }}</span>
                </v-tooltip>
                <span
                  v-if="item.key && receivedData.headers.some(
                    h => h.key === item.key + '_UOM'
                  )"
                  class="uom"
                >
                  &nbsp;{{
                    receivedData.headers.find(
                      h => h.key === item.key + '_UOM'
                    ).value
                  }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="top-content" v-else>
        <test-loaders />
      </div>
    </div>

    <!-- Table with sampleType as heading and all available sample data -->
    <div v-if="sampleData" class="table-wrap">
      <div class="table-title-div" v-if="tableItems.length > 0">
        <p class="table-title">{{ getSampleType() }}</p>
        <div class="csv-btn" @click="downloadTableCSV">
          <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
        </div>
      </div>
      
      <!-- Skeleton loader while loading -->
      <div v-if="loading" class="skeleton-loader">
        <div class="skeleton-header"></div>
        <div v-for="i in 8" :key="i" class="skeleton-row">
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
        </div>
      </div>
      
      <v-data-table 
        v-else-if="tableItems.length > 0" 
        :headers="tableHeaders"
        :items="tableItems"
        :loading="false" 
        fixed-header 
        max-height="calc(100vh - 380px)"
        :items-per-page="-1"
        :page="1"
        hide-default-footer
        class="sample-info-table">
        <template v-slot:headers>
          <tr class="main-header">
            <th class="sticky-header">Key</th>
            <th class="sticky-header">Value</th>
          </tr>
        </template>
        <template v-slot:body="{ items }">
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.propertyName }}</td>
            <td>
              <v-tooltip location="top" v-if="typeof item.value === 'number'">
                <template v-slot:activator="{ props }">
                  <span v-bind="props" class="value-text">
                    {{ item.digits > 0 ? item.value.toFixed(item.digits) : item.value }}
                  </span>
                </template>
                <span>{{ item.value }}</span>
              </v-tooltip>
              <span v-else class="value-text">{{ item.value || '-' }}</span>
              <span v-if="item.unit" class="uom">&nbsp;{{ item.unit }}</span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div v-else class="no-data-message">
        <h4>No properties available for this sample.</h4>
      </div>
    </div>

    <!-- Skeleton loader for initial loading state -->
    <div v-else-if="loading" class="skeleton-container">
      <div class="skeleton-table">
        <div class="skeleton-header"></div>
        <div v-for="i in 8" :key="i" class="skeleton-row">
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
        </div>
      </div>
    </div>

    <v-snackbar v-model="snackbarMessage" color="#E53535" timeout="3000" v-if="snackbarMessage != null">
      Error : {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import TestLoaders from '../Loaders/TestLoaders.vue';
import axios from "axios";
import api from "../../../axiosInterceptor";
import { getTenantPrefix } from "../../../utils/tenant";
import { getDisplayName, getSortOrder } from '../../../utils/cache';
import { blobFromSampleReportResponse } from '../../../utils/sampleReportDownload';

export default {
  components: { TestLoaders },
  name: "SampleInformationTabs",
  data: () => ({
    receivedData: null,
    assetName: "",
    fieldName: "",
    wellName: "",
    pdf_icon: require("../../../assets/Images/pdfIcon.svg"),
    pdf_loader_image: require("../../../assets/Images/pdfLoader.gif"),
    documentDownload: require("../../../assets/Images/csv.svg"),
    pdfLoader: false,
    snackbarMessage: null,
    sampleData: null,
    loading: true,
    tableHeaders: [],
    tableItems: [],
    headerSortOrder: [],
    tableSortOrder: []
  }),
  methods: {
    displayValue(key, value) {
      if (value === null || value === undefined) return "-";
      if (typeof value === "number") {
        return value.toFixed(3);
      }
      return value;
    },

    goToPdf() {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      const tenantId = localStorage.getItem("tenantId");
      const sampleId = localStorage.getItem("sampleId");
      axios
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "X-TenantID": tenantId,
          },
          responseType: 'blob',
        })
        .then(async (response) => {
          const result = await blobFromSampleReportResponse(response, 'pdf');
          this.pdfLoader = false;
          if (!result.ok) {
            this.snackbarMessage = result.message;
            return;
          }
          const url = URL.createObjectURL(result.blob);
          window.open(url, '_blank');
        })
        .catch(async (error) => {
          this.pdfLoader = false;
          const data = error.response?.data;
          if (data instanceof Blob) {
            try {
              const text = await data.text();
              const j = JSON.parse(text);
              if (j && j.message) {
                this.snackbarMessage = j.message;
                return;
              }
            } catch (_) {
              /* fall through */
            }
          }
          if (error.response) {
            this.snackbarMessage = "The PDF report is not available for synthetic data in this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.";
          }
        })
        .finally(() => {
          this.pdfLoader = false;
        });
    },

    downloadTableCSV() {
      // Check if table has items
      if (this.tableItems && this.tableItems.length > 0) {
        const fileName = `sample_information_table.csv`;

        // Prepare CSV header dynamically from table headers
        const csvHeader = this.tableHeaders.map((header) => header.title);

        // Prepare CSV rows from table data
        const csvRows = this.tableItems.map((item) => {
          let formattedValue = item.value;
          
          // Format numbers with proper decimal places
          if (typeof item.value === 'number') {
            formattedValue = item.digits > 0 ? item.value.toFixed(item.digits) : item.value;
          } else if (item.value === null || item.value === undefined) {
            formattedValue = '-';
          }
          
          // Add unit if available
          if (item.unit) {
            formattedValue = `${formattedValue} ${item.unit}`;
          }
          
          return [item.propertyName, formattedValue];
        });

        // Concatenate header and rows
        const csvContent = [
          csvHeader.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        // Create Blob with CSV content
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        // Create link element to trigger download
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },

    async fetchSampleData() {
      try {
        const sampleId = this.$route.params.sampleId;
        if (sampleId) {
          const response = await api.get(`/public/api/samples/${sampleId}`);
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.sampleData = response.data.data;
            await this.processSampleData();
            await this.processHeaderData();
          } else {
            console.error('Error fetching sample data:', response?.data?.message);
          }
        }
      } catch (error) {
        console.error('Error fetching sample data:', error);
      }
    },

    async processHeaderData() {
      try {
        // Get header sort order from cache
        this.headerSortOrder = await getSortOrder("sample", "sample_validation", "header");
        
        // Get header information from pageData.sampleValidationHeader
        if (this.sampleData && this.sampleData.pageData && this.sampleData.pageData.sampleValidationHeader) {
          const headerData = this.sampleData.pageData.sampleValidationHeader;
          
          // Create headers structure with proper sorting and display names
          const headers = [];
          
          if (Array.isArray(headerData)) {
            // Sort header items according to headerSortOrder
            const sortedHeader = [...headerData].sort((a, b) => {
              const indexA = this.headerSortOrder.indexOf(a.key);
              const indexB = this.headerSortOrder.indexOf(b.key);
              return indexA - indexB;
            });

            for (const item of sortedHeader) {
              const { key, value } = item;
              
              // Convert display key to camelCase for getDisplayName
              const camelCaseKey = key
                .split(' ')
                .map((word, index) => 
                  index === 0 
                    ? word.toLowerCase() 
                    : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join('');

              let displayName, digits;
              try {
                const res = await getDisplayName('sample', camelCaseKey);
                displayName = res.displayName || key;
                digits = res.digits != null ? res.digits : 0;
              } catch {
                displayName = key;
                digits = 0;
              }

              headers.push({
                displayName: displayName,
                key: camelCaseKey,
                value: value,
                digits: digits,
                sortOrder: headers.length + 1
              });
            }
          }

          // Set the receivedData with headers structure
          this.receivedData = {
            headers: headers,
            testID: this.sampleData?.ID || ""
          };
        } else {
          // Fallback to basic header structure if pageData is not available
          this.receivedData = {
            headers: [
              { displayName: "Sample ID", key: "sampleId", value: this.sampleData?.fluidSampleID || this.sampleData?.ID, digits: 0, sortOrder: 1 },
              { displayName: "Asset", key: "asset", value: this.sampleData?.location?.asset, digits: 0, sortOrder: 2 },
              { displayName: "Field", key: "field", value: this.sampleData?.location?.field, digits: 0, sortOrder: 3 },
              { displayName: "Well", key: "well", value: this.sampleData?.location?.well, digits: 0, sortOrder: 4 }
            ],
            testID: this.sampleData?.ID || ""
          };
        }
      } catch (error) {
        console.error('Error processing header data:', error);
        // Fallback to basic header structure
        this.receivedData = {
          headers: [
            { displayName: "Sample ID", key: "sampleId", value: this.sampleData?.fluidSampleID || this.sampleData?.ID, digits: 0, sortOrder: 1 },
            { displayName: "Asset", key: "asset", value: this.sampleData?.location?.asset, digits: 0, sortOrder: 2 },
            { displayName: "Field", key: "field", value: this.sampleData?.location?.field, digits: 0, sortOrder: 3 },
            { displayName: "Well", key: "well", value: this.sampleData?.location?.well, digits: 0, sortOrder: 4 }
          ],
          testID: this.sampleData?.ID || ""
        };
      }
    },

    getSampleValue(key) {
      // Map metadata keys to sample data values
      if (!this.sampleData) return null;

      const keyMappings = {
        'sampleId': this.sampleData.fluidSampleID || this.sampleData.ID,
        'asset': this.sampleData.location?.asset,
        'field': this.sampleData.location?.field,
        'well': this.sampleData.location?.well,
        'reservoir': this.sampleData.location?.reservoir,
        'fluidType': this.sampleData.fluidType,
        'sampleType': this.sampleData.sampleType,
        'fluidClassification': this.sampleData.fluidClassification,
        'temperature': this.sampleData.temperature,
        'pressure': this.sampleData.pressure,
        'density': this.sampleData.density,
        'viscosity': this.sampleData.viscosity,
        'molecularWeight': this.sampleData.molecularWeight,
        'apiGravity': this.sampleData.apiGravity,
        'gasOilRatio': this.sampleData.gasOilRatio,
        'bubblePointPressure': this.sampleData.bubblePointPressure,
        'dewPointPressure': this.sampleData.dewPointPressure
      };

      return keyMappings[key] || this.sampleData[key] || null;
    },

    async processSampleData() {
      if (!this.sampleData) {
        return;
      }

      try {
        // Determine table sort order parameter based on sample type
        let tableSortOrderParam = "table"; // default fallback
        const sampleType = this.sampleData.sampleType;
        
        switch (sampleType) {
          case "Bottomhole Sample (BHS)":
            tableSortOrderParam = "table_bhs";
            break;
          case "Recombined Reservoir Fluid (RRF)":
            tableSortOrderParam = "table_rrf";
            break;
          case "Separator Gas":
            tableSortOrderParam = "table_sp_gas";
            break;
          case "Separator Liquid":
            tableSortOrderParam = "table_sp_liquid";
            break;
          case "Separator Oil":
            tableSortOrderParam = "table_sto_stc";
            break;
          case "Wellhead Sample (WHS)":
            tableSortOrderParam = "table_whs";
            break;
          case "MUD OBM":
            tableSortOrderParam = "table_obm_wbm";
            break;
          case "MUD WBM":
            tableSortOrderParam = "table_obm_wbm";
            break;
          default:
            tableSortOrderParam = "table_comingled";
            break;
        }

        // Get table sort order from cache with the determined parameter
        this.tableSortOrder = await getSortOrder("sample", "sample_validation", tableSortOrderParam);

        // Create table headers for key-value structure
        this.tableHeaders = [
          {
            title: 'Key',
            key: 'propertyName',
            align: 'start',
            sortable: false
          },
          {
            title: 'Value',
            key: 'value',
            align: 'start',
            sortable: false
          }
        ];

        this.tableItems = [];

        // Check if sampleData.sample exists, otherwise use sampleData directly
        const dataSource = this.sampleData.sample || this.sampleData;
        
        // Only process keys that are present in the tableSortOrder
        if (this.tableSortOrder && this.tableSortOrder.length > 0) {
          // Process each key in the sort order
          let rowOrder = 1;
          for (const key of this.tableSortOrder) {
            const value = dataSource[key];
            
            // Only include non-null, non-undefined, non-array values that exist in dataSource
            if (key in dataSource && value !== null && value !== undefined && !Array.isArray(value) && typeof value !== 'object') {
              // Get display name and digits from cache
              let displayName, digits;
              try {
                const res = await getDisplayName('sample', key);
                displayName = res.displayName || this.formatHeaderName(key);
                digits = res.digits != null ? res.digits : 0;
              } catch {
                displayName = this.formatHeaderName(key);
                digits = 0;
              }

              const tableItem = {
                propertyName: displayName,
                value: value,
                unit: this.getUnitForProperty(key, dataSource),
                digits: digits,
                originalKey: key,
                rowOrder: rowOrder
              };
              this.tableItems.push(tableItem);
              rowOrder++;
            }
          }
        }

        // Store location information for breadcrumb navigation
        if (dataSource.location) {
          localStorage.setItem("sampleId", dataSource.ID);
          if (dataSource.location.asset) {
            this.assetName = dataSource.location.asset;
          }
          if (dataSource.location.field) {
            this.fieldName = dataSource.location.field;
          }
          if (dataSource.location.well) {
            this.wellName = dataSource.location.well;
          }
        }

        this.loading = false;
      } catch (error) {
        console.error('Error processing sample data:', error);
        this.loading = false;
      }
    },

    formatHeaderName(key) {
      // Convert camelCase or snake_case to readable format
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/_/g, ' ')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    },

    getUnitForProperty(key, dataSource) {
      // First try to get unit from the data source using _UOM suffix
      const uomKey = key + '_UOM';
      if (dataSource && dataSource[uomKey]) {
        return dataSource[uomKey];
      }
      
      // If no UOM field found, return empty string
      return "";
    },

    getSampleType() {
      // Try to get sample type from different possible locations in the data structure
      const dataSource = this.sampleData?.sample || this.sampleData;
      
      // Check multiple possible locations for sample type
      const sampleType = dataSource?.sampleType || 
                        this.sampleData?.sampleType || 
                        dataSource?.fluidType ||
                        this.sampleData?.fluidType ||
                        dataSource?.type ||
                        this.sampleData?.type;
      
      // If we found a sample type, return it, otherwise return a default
      if (sampleType) {
        return sampleType;
      }
      
      // Fallback to 'Sample Properties' if no sample type is found
      return 'Sample Properties';
    }
  },
  mounted() {
    this.assetName = this.$route.params.asset?.replace(/-/g, ' ') || '';
    this.fieldName = this.$route.params.field?.replace(/-/g, ' ') || '';
    this.wellName = this.$route.params.well || '';
    this.fetchSampleData();
  },
};
</script>

<style scoped>

.pointer {
  cursor: pointer;
}

/* Skeleton Loader Styles */
.skeleton-loader {
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 16px;
}

.skeleton-header {
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
}

.skeleton-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 8px;
}

.skeleton-cell {
  height: 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

.skeleton-container {
  margin-top: 16px;
}

.skeleton-table {
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style> 